/* clone-rv-scroll: link có [data-rv-scroll] trỏ tới "#id" → cuộn mượt tới phần tử đó (vd. buy box #rv-buy).
   Không tìm thấy đích thì để trình duyệt xử lý như link thường. Dùng chung cho clone-rv-guarantee, clone-rv-sticky-offer. */
if (!window.rvScrollBound) {
  window.rvScrollBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-rv-scroll]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (!href.startsWith('#') || href.length < 2) return;
    let target = null;
    try {
      target = document.querySelector(href);
    } catch (e) {
      target = null;
    }
    if (!target) return;
    event.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', href);
  });
}
